import {KilnOverviewActions} from './KilnOverviewActions'
import {KilnOverviewLabel} from './KilnOverviewLabel'

export const KilnOverviewCardHeader: React.FC = () => {
  return (
    <div className={'flex flex-col gap-4'}>
      <div
        className="flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-center"
        data-cy="kiln_shutdowns_card_header"
      >
        <KilnOverviewLabel />
        <KilnOverviewActions />
      </div>
    </div>
  )
}
